import { render, staticRenderFns } from "./FeesAndPointsRoomType.vue?vue&type=template&id=e05b6740&"
import script from "./FeesAndPointsRoomType.vue?vue&type=script&lang=js&"
export * from "./FeesAndPointsRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports